import api from '..'

const requests = {
    fetchUsers: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/wellful/UserProfile/`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })

        return response.data
    },
    fetchUsersForExport: async (search) => {
        var response = await api.get(`/wellful/UserProfile/`, {
            params: {
                search: search,
                sortKey: null,
                sortType: null,
                pageSize: -1,
                pageNo: 0
            }
        })
        return response.data.data
    }
}

export default requests
